<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<ngx-spinner bdColor="rgba(0,0,0,0.84)" size="medium" color="#038f98" type="ball-clip-rotate-multiple"
[fullScreen]="true">
<p style="color: white">{{'GLOBAL.LABELS.LOADING' | translate}}</p>
</ngx-spinner>
